const deleteDuplicatePointsLibrary = (component) => {
  return component?.filter(
    (component, index, self) =>
      index === self.findIndex((t) => t.libraryId === component.libraryId)
  );
};

export default deleteDuplicatePointsLibrary;
